import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
})
export class ToggleButtonComponent {
  whiteDimmedColor = 'rgba(white, 0.3)';
  @Input() caption: string = 'TOGGLE';
  @Input() activated = true;
  @Input() disabled = false;
  @Input() tooltip = '';
  @Input() useWarningIcon = false;
  @Input() dashed = false;
  @Input() color = 'rgba(white, 0.3)';

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  toggle(): void {
    this.activated = !this.activated;
    this.clicked.emit();
  }
}
